var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 8.16667H14.8333C15.7667 8.16667 16.2335 8.16667 16.59 8.34832C16.9036 8.50811 17.1585 8.76308 17.3183 9.07668C17.5 9.4332 17.5 9.89991 17.5 10.8333V16.5M10.8333 16.5V4.16667C10.8333 3.23325 10.8333 2.76654 10.6517 2.41002C10.4919 2.09641 10.2369 1.84144 9.92331 1.68166C9.56679 1.5 9.10008 1.5 8.16666 1.5H5.16666C4.23324 1.5 3.76653 1.5 3.41001 1.68166C3.0964 1.84144 2.84143 2.09641 2.68165 2.41002C2.49999 2.76654 2.49999 3.23325 2.49999 4.16667V16.5M18.3333 16.5H1.66666M5.41666 4.83333H7.91666M5.41666 8.16667H7.91666M5.41666 11.5H7.91666",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBuilding);
export default __webpack_public_path__ + "static/media/newBuilding.4fcf54fa50dac7e598edd1b3760ced63.svg";
export { ForwardRef as ReactComponent };